// @ts-nocheck
import React from 'react';
import { Grid } from '@mui/material';

export const ActivateCaptcha = ({refresh})=>
{


  return(
        <Grid container alignItems="center" sx={{mb:1}}>
            <Grid item>
            <img src={"/anywhere/api/users/captcha?t=" + refresh} alt="Code"></img>
            {/* <Captcha bgColor={"#ccc"} width={300} height={50} code="5 + 4 ="/> <Grid item>
            <IconButton onClick={onRefreshHandler}><Refresh></Refresh></IconButton>
            </Grid>*/}
            </Grid>
            
         

        </Grid>
        );
  }